import { IPaginationResult } from 'lib/ajax-helper';
import { useQuery, UseQueryOptions } from 'react-query';
import { getUserProfile, IUserProfile } from 'services/api-accounts.service';
import {
  getUserWallet,
  ICustomer,
  ICustomerRequest,
  indexUsers,
  IUserWalletParams,
} from 'services/api-ops.service';
import {
  getUserVerifications,
  IUserVerifications,
} from 'services/api-verifications.service';

const QUERY_KEYS = {
  GET_USER_BY_ID: 'GET_USER_BY_ID',
  INDEX_USERS: 'INDEX_USERS',
  GET_LOYALTY_CARD: 'GET_LOYALTY_CARD',
  GET_USERWALLET_BY_ID: 'GET_USERWALLET_BY_ID',
  GET_USERVERIFICATION_BY_ID: 'GET_USERVERIFICATION_BY_ID',
  GET_TICKETTAGS: 'GET_TICKETTAGS',
} as const;

export const useGetUserById = (
  userId: string,
  options?: UseQueryOptions<IUserProfile>
) =>
  useQuery(
    [QUERY_KEYS.GET_USER_BY_ID, userId],
    () => getUserProfile(userId),
    options
  );

export const useIndexUsers = (
  params: ICustomerRequest,
  options?: UseQueryOptions<IPaginationResult<ICustomer>>
) =>
  useQuery([QUERY_KEYS.INDEX_USERS, params], () => indexUsers(params), options);

export const useGetUserWalletById = (
  userId: string,
  options?: UseQueryOptions<IUserWalletParams>
) =>
  useQuery(
    [QUERY_KEYS.GET_USERWALLET_BY_ID, userId],
    () => getUserWallet(userId),
    options
  );

export const useGetUserVerificationsById = (
  userId: string,
  options?: UseQueryOptions<IUserVerifications>
) =>
  useQuery(
    [QUERY_KEYS.GET_USERVERIFICATION_BY_ID, userId],
    () => getUserVerifications(userId),
    options
  );

export const useGetTicketTags = (zendeskClient: any) =>
  useQuery(
    [QUERY_KEYS.GET_TICKETTAGS],
    async () => {
      const ticket = await zendeskClient.get('ticket.tags');
      return ticket['ticket.tags'];
    },
    {
      enabled: !!zendeskClient,
    }
  );
